import { CRM_PRESENTATION } from "../../../helper/crmCatalog";

export const CRM_OTHER_LABEL = "Other";
export const CRM_NONE_LABEL = "I don't use a CRM";
export const CRM_SUGGESTIONS = [
  ...Object.entries(CRM_PRESENTATION).map(([provider, { label, logo }]) => ({ label, provider, iconSrc: logo })),
  { label: CRM_OTHER_LABEL, provider: "other" },
  { label: CRM_NONE_LABEL, provider: "none" },
];

export function toggleCrmSelection(current, label) {
  if (current.includes(label)) return current.filter((item) => item !== label);
  if (label === CRM_NONE_LABEL) return [label];
  return [...current.filter((item) => item !== CRM_NONE_LABEL), label];
}

export function parseCrmStepAnswer(pendingSelection, text) {
  const raw = String(text || "").trim();
  const picked = [...pendingSelection];
  let otherName = null;
  if (picked.includes(CRM_OTHER_LABEL)) {
    otherName = raw === picked.join(", ") ? "" : raw;
  } else if (raw && raw !== picked.join(", ")) {
    for (const part of raw.split(/[,;]+/).map((value) => value.trim()).filter(Boolean)) {
      const namedOther = part.match(/^other\s*[:·-]\s*(.+)$/i);
      if (namedOther) { picked.push(CRM_OTHER_LABEL); otherName = namedOther[1].trim(); continue; }
      const choice = CRM_SUGGESTIONS.find((item) => item.label.toLowerCase() === part.toLowerCase());
      if (!choice) return { ok: false };
      picked.push(choice.label);
    }
  }
  const choices = [...new Set(picked)].map((label) => CRM_SUGGESTIONS.find((item) => item.label === label));
  if (!choices.length || choices.some((choice) => !choice)) return { ok: false };
  const providers = choices.map((choice) => choice.provider);
  if (providers.includes("none") && providers.length > 1) return { ok: false };
  if (providers.includes("other") && (!otherName || otherName.length > 200)) return { ok: false };
  return {
    ok: true,
    value: { crmPreference: { providers, other_name: providers.includes("other") ? otherName : null } },
    display: choices.map((choice) => choice.provider === "other" ? `Other: ${otherName}` : choice.label).join(", "),
  };
}
